import env from 'env/dev'

export const BaseURL = env.BASEURL

export const isProduction = process.env.NODE_ENV === 'production'

export enum COOKIE_KEYS {
  token = 'token',
  staffId = 'staff_id',
}

export enum LOCALSTORAGE_KEYS {
  userInfo = 'user_info',
  collapsed = 'menu_collapsed',
  navOpenKeys = 'nav_open_keys',
}

export enum SOURCE_TYPES {
  video = '1000101',
  word = '1000102',
  voice = '1000103',
}

// 关卡类型与状态
export const checkType = {
  integration: '综合关',
  example: '习题关',
  exam: '必通关',
  text: '文字关',
}

export const checkStatus = {
  todo: '待通关',
  doing: '通关中',
  done: '已通关',
  timeout: '已超时',
  discard: '已作废',
}

// 关卡下的任务类型与状态
export const taskType = {
  video: '看视频',
  example: '做题',
  exam: '考试',
  text: '看文字',
}

export const templateType = {
  unit: '单位关卡',
  district: '片区关卡',
  head: '总部关卡',
}

export const taskStatus = {
  todo: '未开始',
  unfinished: '未完成',
  doing: '进行中',
  done: '已完成',
  discard: '已作废',
}

export const taskCompletedStatus = {
  overtime: {
    是: {
      [taskStatus.doing]: 'expired',
      [taskStatus.done]: 'completed',
    },
    否: {
      [taskStatus.unfinished]: 'undo',
      [taskStatus.todo]: 'undo',
      [taskStatus.doing]: 'undo',
      [taskStatus.done]: 'completed',
    },
  },
}

export const LEVEL_CONFIG_INFO = [
  [
    '配置信息提示',
    '配置场景：目前默认可选员工进阶，针对系统入职3个月以内的新人未转正员工；',
  ],
  [
    '添加关卡模版',
    '导入新人进阶标准关卡：该功能按钮点击后，将清空当前所有配置的关卡（包括通关一半未完全通关的情况），并且自动导入总部预设的标准关卡配置数据，导入后可根据单位实际情况进行自行调整；',
  ],
  [
    '添加关卡',
    '目前共可配置三种关卡；其中关卡名字对应 ○ 处内容，字数限制在 4 个字范围内，如需写文字较多可在关卡描述框进行描述；',
    '员工浏览的通关页面关卡排序为当前配置页的排序展示。最后一关必须为必通关，否则不能触发完全通关；',
  ],
  [
    '关卡说明',
    '• 综合关：支持导入观看视频、做练习题任务与工作文字指引任务；员工必须完整的看完配置的视频和做一遍配置的题目，或者按要求完成指定工作才能通关；',
    '• 习题关：只支持导入练习题，员工必须做一遍才可通关；',
    '• 必通关：只支持导入试题，员工必须全部作对才可通关；其中综合题可在通关情况查看；',
    '• 文字关：可输入纯文字公告或指引，员工必须阅读才可进入下一关；',
  ],
  [
    '关卡功能说明',
    '• 添加视频任务：输入需要导入的综合关键字，在搜索结果框选中该视频，点击勾选，添加成功；',

    '• 添加习题/通关任务：输入需要导入的试题关键字，在搜索结果框选中该试题，点击勾选，添加成功；',

    '• 通关天数：设置后该关卡如新人超过限制天数还没通关，相关负责人会收到通知（组长）；',

    '• 视频数量：限制了该综合关一共能放多少个视频；',

    '• 时长限制：显示了该综合关总共要看的时长；',

    '• 升/降/删：点击升/降，可对关卡进行排序，点击删除按钮将会删除该关卡；',

    '• +视频/习题/必通关：在该关卡下方插入一个对应按钮的关卡。',
  ],
]

export const getWelcomeInfo = (info: { name: string; type: string }) => {
  const newbie = [
    ['h2', '致新人的一封信'],
    [
      'p',
      `<em>${
        info.name
      }</em>，你好，欢迎加入我们经传大家庭。这里给你准备了一套员工晋升必须学习和掌握的课程，希望你通过学习，挑战成功，最终顺利成为一名经传精英。`,
    ],
    [
      'p',
      `该课程囊括了我们的公司介绍、企业文化、产品知识、股票基础知识以及基础的网销出单手法。在接下来的两个月，学院将会分阶段给你派发学习关卡。`,
    ],
    [
      'p',
      `每完成一个关卡，就能升级进入下一关。该关卡内容是根据我们体系中优秀团队和精英的成长模型提炼所得，希望能够帮助到你——更好更快地适应岗位以及更轻松更容易出高业绩拿高工资。`,
    ],
    ['p', '如你已知晓规则，请点击“<strong>开启闯关</strong>”，即刻挑战。'],
  ]

  const teamLeader = [
    ['h2', '组长进阶说明'],
    ['p', `<em>${info.name}</em>，恭喜您晋升组长！`],
    ['p', '接下来的团队之路，相信您能培养出更多精英，带领团队创造佳绩。'],
    [
      'p',
      `为了您更好地胜任组长一职，已为您准备组长相关能力角度的培养与考核提升，包含：
    <strong>职场素养</strong>、<strong>培训复制</strong>、<strong>业务提升</strong>、<strong>面试能力</strong>、<strong>时间管理</strong>、<strong>沟通</strong>、<strong>情商</strong>、<strong>发展规划</strong>等 15 个能力角度。`,
    ],
    [
      'p',
      '该内容取自全国优秀管理者经验，采用线上视频学习，问题思考，线下课程输出，团队传递形式培养。学院将按能力模块为您派发关卡，请按关卡指示完成任务。',
    ],
    ['p', '如您已知晓规则，请点击通关，即刻挑战！'],
  ]

  const head = [
    ['h2', '主管进阶说明'],
    ['p', `<em>${info.name}</em>，恭喜您晋升主管！`],
    [
      'p',
      `无论是创业，还是成为团队合伙人，5年一百万的目标越来越近。职位越高、团队越大、欲望越强，同样也要求您有匹配的品质与能力。`,
    ],
    [
      'p',
      `为您更好地成就事业目标，已为您准备相关能力角度的培养提升，包含：<strong>管理者素养与职责</strong>、<strong>招聘留人</strong>、<strong>培训复制</strong>、<strong>目标规划</strong>、<strong>文化打造</strong>、<strong>核心培养</strong>、<strong>团队沟通</strong>、<strong>数据分析</strong>等能力角度。`,
    ],
    [
      'p',
      `该内容取自全国优秀管理者经验，采用线上视频学习，问题思考，线下课程输出，团队传递形式培养。学院将按能力模块为您派发关卡，请按关卡指示完成任务。`,
    ],
    ['p', '如您已知晓规则，请点击通关，即刻通关！'],
  ]

  const welcomeInfo = {
    ['新人']: newbie,
    ['组长']: teamLeader,
    ['主管']: head,
  }

  return welcomeInfo[info.type]
}

export const ADVANCED_INFO = [
  [
    '一、新人进阶',
    '第一阶段：入职1周， 以天为单位，每天一个学习关卡。',
    '第二阶段：入职第2-4周，以天为单位，每天发放一个学习关卡。',
    '第三阶段：入职第5-8周，以周为单位，每周学习一个关卡。',
  ],
  [
    '二、关卡类型',
    '1、综合关（文字+视频+习题），通关条件:完整看完视频和做完习题',
    '2、习题关 通关条件：做完每一道题',
    '3、必通关 通关条件：正确答对所有客观题（单选、多选、判断）',
    '4、文字关（公告或提示内容），通关条件：完整阅读',
  ],
  [
    '三、全部通关',
    '完成所有关卡即可通关；下一个关卡（精英、组长等）待员工属性改变',
    '后开启，敬请期待！',
  ],
]

// 七牛相关
export const QN_LOCATION =
  location.protocol === 'http:'
    ? 'http://up-z0.qiniu.com'
    : 'https://up-z0.qbox.me'
export const QN_URL_PREFIX = 'https://ss.yidejia.com/'

export const UPLOAD_URL = '/api/upload/token'
